import { useState } from "react";
import {
  View,
  Text,
  Linking,
  ScrollView,
} from "react-native";
import { Router, useRouter } from "expo-router";
import AsyncStorage from "@react-native-async-storage/async-storage";

import { useDispatch } from "react-redux";
import { AppDispatch } from "@/_store/store";
import { clearAuthToken } from "@/_reducers/accounts.reducer";
import {
  useCreateAcceptanceMutation,
  useGetPersonalDataAgreementQuery,
} from "@/_store/currentUser/currentUser.slice";
import CustomButton from "@/app/components/CustomButton";
import CustomCheckbox from "@/app/components/CustomCheckbox";
import Container from "@/app/components/Container";
import {getErrorMessage} from "@/_utils/getErrorMessage";

const UserAgreement = () => {
  const [isPrivacyPolicyAccepted, setIsPrivacyPolicyAccepted] = useState<boolean>(false);
  const [isTermsOfServiceAccepted, setIsTermsOfServiceAccepted] = useState<boolean>(false);

  const [createAcceptance, { error }] = useCreateAcceptanceMutation();
  const { data: personalAgreement } = useGetPersonalDataAgreementQuery();

  const {
    consent_personal_data,
    policy_personal_data,
  } = personalAgreement ?? {};

  const dispatch = useDispatch<AppDispatch>();
  const router: Router = useRouter();

  const isButtonDisabled: boolean = !isPrivacyPolicyAccepted || !isTermsOfServiceAccepted;

  const handleLogOut = async (): Promise<void> => {
    dispatch(clearAuthToken());
    await AsyncStorage.removeItem("token");
    router.replace("/login");
  };

  const onSubmit = async (): Promise<void> => {
    try {
      await createAcceptance({
        consent_personal_accepted: isPrivacyPolicyAccepted,
        policy_personal_accepted: isTermsOfServiceAccepted,
      }).unwrap();

      router.replace("/general");
    } catch (err) {
      console.error("Create acceptance error:", err);
    }
  };

  const openFileLink = (url: string): Promise<void> => Linking.openURL(url);

  return (
    <Container>
      <ScrollView className="flex-1">
        <View className="flex-1 items-start justify-center">
          <Text className="text-header mb-6">Добро пожаловать!</Text>
          <Text className="text-base mb-6">
            Прежде чем начать, пожалуйста, подтвердите согласие с{" "}
            <Text
              className="text-blue-600 underline"
              onPress={() => openFileLink(consent_personal_data?.file_url ?? "")}
            >
              Политикой обработки персональных данных
            </Text>{" "}
            и условиями{" "}
            <Text
              className="text-blue-600 underline"
              onPress={() => openFileLink(policy_personal_data?.file_url ?? "")}
            >
              Публичной оферты
            </Text>
            .
          </Text>
          <CustomCheckbox
            label="Согласен(а) с Политикой обработки персональных данных"
            value={isPrivacyPolicyAccepted}
            onChange={setIsPrivacyPolicyAccepted}
            className="mb-2"
          />
          <CustomCheckbox
            label="Принимаю условия Публичной оферты"
            value={isTermsOfServiceAccepted}
            onChange={setIsTermsOfServiceAccepted}
            className="mb-6"
          />
          <CustomButton
            className="w-full mb-6"
            title="Продолжить"
            onPress={onSubmit}
            disabled={isButtonDisabled}
          />
          <CustomButton
            className="w-full"
            title="Выйти"
            type="text"
            onPress={handleLogOut}
          />
          {error && (
            <Text className="mt-4 text-red-600 text-center">
              {getErrorMessage(error) || "Произошла ошибка при отправке согласия"}
            </Text>
          )}
        </View>
      </ScrollView>
    </Container>
  );
};

export default UserAgreement;
